import {
  BrandsPublicStoreSearchSuccessSchema,
  type BrandsPublicStoreSearchSuccess
} from '~/services/api/generated'
import type {
  BrandStoreSearchResponse,
  BrandStoreSearchStore
} from '~/services/api/interfaces/Brand'
import type { ResponseWrapper } from '~/services/api/interfaces/Common'

type BrandStoreSearchWireResult = BrandsPublicStoreSearchSuccess['data']['results'][number]

const normalizeStore = (value: BrandStoreSearchWireResult): BrandStoreSearchStore => ({
  id: value.id,
  name: value.name,
  slug: value.slug,
  cover: value.cover,
  logo: null,
  address: value.address,
  city: value.city,
  state: value.state,
  ...(value.formatted_address === null ? {} : { formatted_address: value.formatted_address }),
  // A null average_rating means no rating exists; review_count is forced to 0 alongside it so a
  // wire inconsistency (a stray positive count with no rating) can never render a blank number.
  average_rating: value.average_rating,
  review_count: value.average_rating === null ? 0 : (value.review_count ?? 0),
  delivery_fee: value.delivery_fee,
  dine_in_available: value.dine_in_available,
  distance_miles: value.distance_miles
})

export const brandStoreSearchContract = Object.freeze({
  fromParsed(response: BrandsPublicStoreSearchSuccess): ResponseWrapper<BrandStoreSearchResponse> {
    return {
      status: response.success,
      data: {
        query: response.data.query,
        count: response.data.count,
        results: response.data.results.map(normalizeStore)
      }
    }
  },
  parse(payload: unknown): ResponseWrapper<BrandStoreSearchResponse> {
    return this.fromParsed(BrandsPublicStoreSearchSuccessSchema.parse(payload))
  }
})
